import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useBoolean } from 'src/hooks/use-boolean';
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import Iconify from 'src/components/iconify';
import { useNavigate } from 'react-router';
// ----------------------------------------------------------------------
export default function UserTableRow({
  row,
  selected,
  onEditRow,
  onSelectRow,
  onDeleteRow,
  currentItem,
  serialNumber,
}) {
  const {
    id,
    statement_type,
    reporting_period,
    company_entity,
    department_division_filter,
    account_grouping,
    include_subtotals_by_category,
    comparative_analysis,
    variance_analysis,
    currency_selection,
    rounding_level,
    notes_annotations,
    auto_calculation_of_ratios,
    approval_workflow,
    export_options,
    scheduled_generation,
  } = row;

  const confirm = useBoolean();
  const popover = usePopover();
  const navigate = useNavigate()

  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onClick={onSelectRow} />
        </TableCell>
        <TableCell>{serialNumber}</TableCell>
        <TableCell>{id}</TableCell>
        <TableCell>{statement_type}</TableCell>
        <TableCell>{reporting_period}</TableCell>
        <TableCell>{company_entity}</TableCell>
        <TableCell>{department_division_filter}</TableCell>
        <TableCell>{account_grouping}</TableCell>
        <TableCell>{include_subtotals_by_category.toString()}</TableCell>
        <TableCell>{comparative_analysis.toString()}</TableCell>
        <TableCell>{variance_analysis.toString()}</TableCell>
        <TableCell>{currency_selection}</TableCell>
        <TableCell>{rounding_level}</TableCell>
        <TableCell>{notes_annotations}</TableCell>
        <TableCell>{auto_calculation_of_ratios.toString()}</TableCell>
        <TableCell>{approval_workflow.toString()}</TableCell>
        {/*<TableCell>{export_options}</TableCell>*/}
        <TableCell>{scheduled_generation.toString()}</TableCell>
        <TableCell align="right" sx={{ px: 1, whiteSpace: 'nowrap' }}>
          <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>
      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ width: 140 }}
      >
        <MenuItem
          onClick={() =>
            navigate(`/accounts-management/finance-list/finance-statement-view/${id}`, {
              state: {
                rowData: row,
                projectID: id,
                rowId: row.id,
              },
            })
          }
        >
          <Iconify icon="solar:eye-bold" />
          View
        </MenuItem>
        <MenuItem
          onClick={() => {
            confirm.onTrue();
            popover.onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          Delete
        </MenuItem>
        <MenuItem
          onClick={() => {
            onEditRow(row);
          }}
        >
          <Iconify icon="solar:pen-bold" />
          Edit
        </MenuItem>
      </CustomPopover>
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content="Are you sure you want to delete?"
        action={
          <Button
            className="dark-button"
            variant="contained"
            color="error"
            onClick={() => {
              confirm.onFalse();
              onDeleteRow(row.id); // Pass row.id to onDeleteRow
              console.log('>>>>>>>', row.id);
            }}
          >
            Delete
          </Button>
        }
      />
    </>
  );
}
UserTableRow.propTypes = {
  onDeleteRow: PropTypes.func,
  onEditRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  row: PropTypes.object,
  selected: PropTypes.bool,
};
